export default __webpack_public_path__ + "static/media/hide.b3e71f00.svg";